import { useMutation } from '@tanstack/react-query';
import { sendLiscioMessage } from 'api/messages';

export function useSendLiscioMessage() {
  return useMutation({
    mutationFn: sendLiscioMessage,
  });
}
